import { MessageCircle } from "lucide-react";
import { useI18n } from "../context/I18nContext";

const FALLBACK_WHATSAPP = "917200079456"; // +91 72000 79456

function digitsOnly(s = "") {
  return s.replace(/[^0-9]/g, "");
}

export default function WhatsappButton({ settings }) {
  const { t } = useI18n();
  const number = digitsOnly(settings?.whatsapp || settings?.mobile || "") || FALLBACK_WHATSAPP;
  const message = encodeURIComponent(t("wa.quoteMsg"));
  const href = `https://wa.me/${number}?text=${message}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-btn"
      className="fixed bottom-6 right-6 z-40 group"
      aria-label="Chat on WhatsApp"
    >
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-[#0A0B0E] text-white text-xs font-mono uppercase tracking-[0.2em] px-3 py-2 border border-[#282C33] opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap hidden sm:block">
        {t("wa.float")}
      </span>
      <span className="flex items-center justify-center w-14 h-14 bg-[#25D366] hover:bg-[#1EBE5C] text-white shadow-[0_0_0_4px_rgba(37,211,102,0.2)] transition-all">
        <MessageCircle size={26} fill="currentColor" />
      </span>
      <span className="absolute inset-0 animate-ping bg-[#25D366] opacity-30 -z-10" />
    </a>
  );
}
